import YouTubePlayer from 'youtube-player';

class FeaturedCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const injectYouTubePlayer = () => {
      // Replace 'YOUR_YOUTUBE_VIDEO_ID' with the actual ID of the YouTube video.
      var videoId =
        this.querySelector('#youtube-player').getAttribute('youtube-url');

      // Construct the YouTube embed URL with the video ID and any desired parameters.

      // Create the iframe element with the YouTube video embedded.
      var iframe = document.createElement('iframe');
      iframe.className = 'top-0 absolute left-0 w-full h-full border-0 z-50';
      iframe.setAttribute('src', videoId);
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute('allow', 'autoplay'); // Allow autoplay without cookies.

      // Add the iframe to the container or location where you want to display the video.
      var container = this.querySelector('#youtube-player');
      container.appendChild(iframe);
    };
    if (this.querySelector('.youtube-button')) {
      this.querySelector('.youtube-button').addEventListener('click', (e) => {
        e.preventDefault();
        this.querySelector('.youtube-modal').classList.remove('hidden');
        injectYouTubePlayer();
      });
    }
    if (this.querySelector('.youtube-modal')) {
      this.querySelector('.youtube-modal').addEventListener('click', (e) => {
        if (!e.target.classList.contains('video-container')) {
          if (this.querySelector('.youtube-modal')) {
            this.querySelector('.youtube-modal').classList.add('hidden');
          }
          this.querySelector('iframe').remove();
        }
      });
    }
  }
}

customElements.define('featured-card', FeaturedCard);
